import React, {memo} from 'react';
import SelectOption from '../common/SelectOption';
import InputField from '../common/InputField';
import { Button } from 'antd';
import {discountPercentageValidation} from "../../helper/FeildValidations";

const rules = [
    {
        required: false,
        message: 'Please Fill Input Field!'
    }
];
const DiscountTest = ({paymentOptionIndex, hoursOrMonths, labelPlaceHolder, index, savings, handleRemoveDiscount, handleAddDiscounts, values }) => {
    return(
        <>
          <SelectOption
              isMultiple={false}
              name={['chargings', paymentOptionIndex, 'discounts', index, 'id']}
              placeholder={'Name'}
              label={'Discount Name'}
              values={savings}
              handleOnSelect={null}
              labelName={'name'}
              valueName={'id'}
              rules={rules}
          />

            <SelectOption
              isMultiple={false}
              name={['chargings', paymentOptionIndex, 'discounts', index, 'term']}
              placeholder={labelPlaceHolder}
              label={labelPlaceHolder}
              values={hoursOrMonths}
              handleOnSelect={null}
          />
          
          <InputField
              name={['chargings', paymentOptionIndex, 'discounts', index, 'amount']}
              label={'Discount %'}
              rules={discountPercentageValidation}
          />

          {index !== 0 && (
            <Button className="minus-btn hourly-duration" onClick={() => handleRemoveDiscount(index)}>
              {' '}
              -{' '}
            </Button>
          )}
          {index === 0 && (
            <Button
              className="plus-btn hourly-duration"
              onClick={() =>
                  handleAddDiscounts()
              }
            >
              +
            </Button>
          )}
        </>
    )

};

export default DiscountTest;